class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.facetForm = this.querySelector('[data-facet-form]');
    this.facetForm.addEventListener(
      'input',
      debounce((event) => {
        this.onSubmitHandler(event);
      }, 300).bind(this),
    );
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const productGrid = document.getElementById('product-grid');
    const url = `${window.location.pathname}?section_id=${productGrid.dataset.id}&${searchParams}`;
    const filterDataUrl = (element) => element.url === url;

    if (FacetFiltersForm.filterData.some(filterDataUrl)) FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
    else FacetFiltersForm.renderSectionFromFetch(url, event);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
      })
      .catch((error) => error);
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderFilters(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll('[data-facet-form] .js-filter');

    const facetsToRender = Array.from(facetDetailsElements);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // uncheck all the options of the same type but the one selected when desktop filters change
    if (this.facetForm.id === 'FacetFiltersFormDesktop') this.refreshForm(event.target);

    const forms = [];
    const isMobile = event.target.closest('form').id.includes('Mobile');

    // join search parameters from all forms before submitting
    FacetFiltersForm.sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetFiltersFormDesktop' || form.id === 'FacetSortForm') {
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortForm') {
        forms.push(this.createSearchParams(form));
      }
    });

    this.onSubmitForm(forms.join('&'), event);
  }

  refreshForm(selectedOption) {
    [
      ...this.facetForm.elements,
    ].forEach((option) => {
      if (option.id !== selectedOption.id && option.name === selectedOption.name) option.checked = false;
    });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.sortFilterForms = document.querySelectorAll('[data-facet-form]');
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.setListeners();
customElements.define('facet-form', FacetFiltersForm);
